module.exports = __webpack_public_path__ + "static/media/info.e473e876.png";